import { useTranslation } from 'react-i18next';
import { useNotifications } from 'pos-client/hooks/useNotifications.tsx';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useUnauthorizeBlockedSlot = (handleClose?: () => void) => {
  const trpcContext = trpc.useUtils();

  const { t } = useTranslation();

  const { showSuccess, showError } = useNotifications();

  const {
    mutate: unauthorizeBlockedSlot,
    isLoading: unauthorizeBlockedSlotIsLoading,
  } = trpc.unAuthorizeBlockedSlot.useMutation({
    onSuccess: () => {
      trpcContext.findScheduleBoardJobsAndBlockedSlots.invalidate();

      showSuccess(
        t('common.notification.success.message', {
          action: 'unauthorized',
          entity: 'blocked slot',
        })
      );

      return handleClose && handleClose();
    },
    onError: () => {
      showError(
        t('common.notification.error.message', {
          action: 'unauthorize',
          entity: 'blocked slot',
        })
      );
      return handleClose && handleClose();
    },
  });

  return {
    unauthorizeBlockedSlot,
    unauthorizeBlockedSlotIsLoading,
  };
};
